import React from 'react';
import classNames from 'classnames';
import { getFormattedDateLabel, getFormattedTimeLabel } from '../../Util';
import { localize } from '../../Util/L10n';
import { useUnavailableWorkshopIds } from '../../Util/UnavailableWorkshops';

const WorkShopSelectButton = function ({
  workshop,
  id,
  onSelectEventClick,
  selected = false,
  disabled = false,
  workshopIsFull = false,
}) {
  return (
    <button
      className={classNames('WorkshopsOverlay__WorkshopSelectButton', {
        'WorkshopsOverlay__WorkshopSelectButton--Selected': selected,
      })}
      onClick={onSelectEventClick}
      data-id={id}
      data-workshop={workshop.id}
      type="button"
      disabled={disabled}
    >
      {selected ? (
        <span>
          <span className="fa fa-check" />{' '}
          {localize(workshopIsFull ? 'waitingList' : 'workshopChosen')}
        </span>
      ) : (
        localize('chooseWorkshopAction')
      )}
    </button>
  );
};

export const WorkshopList = function ({
  id,
  value,
  workshopGroups,
  workshops,
  onSelectEventClick,
}) {
  const unavailableWorkshopIds = useUnavailableWorkshopIds(value, workshops);

  return workshopGroups.map((group, groupKey) => {
    return (
      <div className="WorkshopsOverlay__Group" key={groupKey}>
        <div className="WorkshopsOverlay__GroupTitle">
          {getFormattedDateLabel(group.startDate, group.endDate)}
        </div>
        {group.workshops.map((workshopId) => {
          const workshop = workshops[workshopId];
          const workshopIsAvailable = !unavailableWorkshopIds[workshop.id];
          const workshopSelected = value[workshop.id];
          const workshopIsFull = !workshop.freePlaces;

          return (
            <div className="WorkshopsOverlay__WorkShop" key={workshopId}>
              <div className="WorkshopsOverlay__WorkShopColumnLeft">
                <div className="WorkshopsOverlay__WorkShopDate">
                  {getFormattedTimeLabel(workshop.startDate, workshop.endDate)}
                </div>
                <div className="WorkshopsOverlay__WorkShopTitle">
                  {workshop.name}
                </div>
                {!workshopIsAvailable && (
                  <div className="WorkshopsOverlay__WorkShopAlert">
                    {localize('workshopInPeriodAlreadyChosenAlert')}
                  </div>
                )}
                {workshopIsFull && workshopIsAvailable && (
                  <div className="WorkshopsOverlay__WorkShopAlert">
                    {localize('workshopFullyBookedAlert')}{' '}
                    {localize('addToWaitingListAlert')}
                  </div>
                )}
              </div>
              <div className="WorkshopsOverlay__WorkShopColumnRight">
                <WorkShopSelectButton
                  workshop={workshop}
                  id={id}
                  selected={workshopSelected}
                  disabled={!workshopIsAvailable}
                  onSelectEventClick={onSelectEventClick}
                  workshopIsFull={workshopIsFull}
                />
              </div>
            </div>
          );
        })}
      </div>
    );
  });
};
